import { Controller } from "@hotwired/stimulus";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.element.classList.add("modal--active");
    }, 100);

    disableBodyScroll(this.element);
    window.addEventListener(
      "keydown",
      (this.keydownProxy = this.onKeydown.bind(this))
    );
  }

  disconnect() {
    enableBodyScroll(this.element);
    window.removeEventListener("keydown", this.keydownProxy);
  }

  onKeydown(evt) {
    if (evt.key === "Escape") {
      this.element.remove();
    }
  }

  maybeClose(evt) {
    if (
      evt.target.classList.contains("modal__bg") ||
      evt.target.classList.contains("modal__close")
    ) {
      this.element.remove();
    }
  }
}
